import * as Yup from "yup";

import { yupObjectValidation } from "../../validationServices";

export const useSignupValidationSchema = () => {
  const initialValues = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    changepassword: "",
    name: "",
    comp_name: "",
  };

  const validationSchema = {
    name: yupObjectValidation.name1,
    comp_name: yupObjectValidation.company_name,
    email: yupObjectValidation.email1,
    phone: yupObjectValidation.phone1,
    password: yupObjectValidation.password,
    changepassword: yupObjectValidation.change_password,
  };

  const signupValidationSchema = Yup.object().shape(validationSchema);

  return {
    initialValues,
    signupValidationSchema,
  };
};
